import { useParams } from 'react-router-dom';

import get from 'lodash/get';

import { ListEmployeeDuplicateUsersPage as BaseListEmployeeDuplicateUsersPage } from '@sbv-clients/feature-facilities';

const EmployeeDuplicateUsersPage = () => {
  const params = useParams();
  const databaseName = get(params, 'facilityName', '');
  return <BaseListEmployeeDuplicateUsersPage facilityName={databaseName} />;
};

export default EmployeeDuplicateUsersPage;
